import { Box } from "@mui/material";
import { useMemo } from "react";
import { useRoutes } from "../app/routes";
import s from "./identity.module.scss";

const MobileIdentity = () => {
  const { unAuthRoutes } = useRoutes();
  const res = useMemo(
    () => (
      <div className={s.mobileScrollBox}>
        <Box className={s.mobileInnerBox}>
          <img src="/logo_with_text.png" className={s.logoImage} alt="Tapestry AI logo" />
          {unAuthRoutes()}
        </Box>
      </div>
    ),
    [unAuthRoutes]
  );

  return res;
};

export default MobileIdentity;
